import { inject, Pipe, PipeTransform } from '@angular/core';
import { PropertyPathTokenService } from '../services/property-path-token.service';

@Pipe({
    name: 'replacePropertyPathToken',
})
export class ReplacePropertyPathTokenPipe implements PipeTransform {
    private readonly propertyPathTokenService = inject(PropertyPathTokenService);

    public transform(value: string, object: Record<string, unknown>): string {
        return this.propertyPathTokenService.replaceStringTokens(value, object);
    }
}
